import { MeetingStatsFieldsFragment, useGetMeetingStatsQuery } from '@/@generated/codegen/API';
import { useEntitySubscription } from '@/hooks/useEntitySubscription';

export default function useMeetingStatsData(
  meetingID: string | null | undefined,
  live: boolean
): MeetingStatsFieldsFragment | null {
  const meetingStatsQuery = useGetMeetingStatsQuery({
    variables: {
      where: {
        meetingId: meetingID,
      },
    },
    skip: !meetingID,
  });

  if (live) {
    // NIKO TODO: make sure that the updating of the fragments in the onData of onUpdate works properly
    useEntitySubscription('MeetingStats', {
      onUpdate: {
        variables: {
          where: {
            meetingId: {
              equals: meetingID,
            },
          },
        },
        skip: !meetingID,
      },
    });
  }

  return meetingStatsQuery.data?.getMeetingStats ?? null;
}
